import type { Country } from "@/schema/shared";

export function firstCountryId(countries: readonly Country[]) {
  return countries.at(0)?._id;
}

export function firstOfficeId(countries: readonly Country[]) {
  return countries.at(0)?.offices.at(0)?._id;
}
